import { Injectable, signal, WritableSignal } from '@angular/core';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';

@Injectable({
  providedIn: 'root'
})
export class ViewService {

  // PROPERTIES
  public readonly view: WritableSignal<AppViews|null> = signal<AppViews|null>(null);

  // METHODS
  public setView(view: AppViews|null): void {
    this.view.set(view);
  }

  public resetView(): void {
    this.view.set(null);
  }

}
